import LayoutComponent from "../components/LayoutComponent";
import {Button, Form, Input} from "antd";
import {useState, useEffect} from 'react';
import {useApi} from "../provider/ApiProvider";
import {useHistory} from "react-router-dom";
import CompanySelector from "../components/CompanySelector";
import TextEditor from "../components/TextEditor";
import ImageUpload from "../components/ImageUpload";

import { DatePicker, Space } from 'antd';
import CustomerSelector from "../components/CustomerSelector";
import moment from 'moment';
import FullLoader from "../components/FullLoader";
const { RangePicker } = DatePicker;
const dateFormatList = ['DD.MM.YYYY', 'DD.MM.YYYY'];
const dateFormat = 'DD.MM.YYYY';


// moment.locale('tr_TR');


const {TextArea} = Input;

export default function NewsSavePage(props){
    const {api} = useApi();
    let history = useHistory();

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [imageData, setImageData] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);


    useEffect(() => {
        let id = props.match.params.id;
        load(id);
    }, [props.match.params.id])

    async function load(id){
        if(id){
            await api.get('/newsRouter/news/get/' + id).then(resp => {
                let data = resp.data;
                let date = [moment(data.beginDate), moment(data.endDate)]
                let formData = {
                    image: data?.image,
                    CustomerId: data?.CustomerId,
                    CompanyId: data?.CompanyId,
                    PlatformId: data?.PlatformId,
                    title: data?.title,
                    content: data?.content,
                    date: date
                }
                if(data?.CustomerId){
                    setSelectedCustomer(data.Customer);
                }
                form.setFieldsValue(formData);
            })
        }
    }

    async function onChangeImageUpload(value){
        setImageData(value);
    }

    async function save(values){
        if(props.match.params.id){
            let id = props.match.params.id;
            let params = {
                title: values.title,
                content: values.content,
                CustomerId: values.CustomerId,
                CompanyId: 1,
                PlatformId: selectedCustomer.PlatformId ? selectedCustomer.PlatformId : 1 ,
                isActive: true,
                isDeleted: false
            }
            setLoading(true);
            await api.put('/newsRouter/news/update/' + id, params).then(resp => {
                history.push('/news');
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }else{
            let body = {
                title: values.title,
                content: values.content,
                image: values.image,
                CustomerId: 1,
                CompanyId: values.CompanyId,
                PlatformId: selectedCustomer?.PlatformId ? selectedCustomer?.PlatformId  : 1,
                isActive : true,
                isDeleted : false
            }

            //
            // let formData = new FormData();
            // formData.append('blob',imageData, "new-image");
            //
            await api.post("/newsRouter/news/store",body).then(resp => {
                console.log(resp, 'data')

                if(resp.status === true){
                    history.push('/news');
                }
            })

        }
    }

    async function storeData(params){
        await api.post('/newsRouter/news/store',params).then(resp => {
            history.push('/news');
        })
    }

    return (
        <LayoutComponent links={
            [
                {
                    title: 'Haberler',
                    url: '/news'
                },
                {
                    title: 'Ekle-Düzenle',
                    url: '/'
                },

            ]}
        >
            <div>
                <FullLoader show={loading}/>

                {/*<ImageUpload value={imageData} name={"image"} onChange={onChangeImageUpload} />*/}
                {/*<div style={{marginBottom: '10px'}}>*/}
                {/*    {form.getFieldValue('image') && (*/}
                {/*        <img src={form.getFieldValue('image')} height={200}/>*/}

                {/*    )}*/}

                {/*</div>*/}
                <Form
                    form={form}
                    name="basic"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={save}
                    onFinishFailed={() => {}}
                >
                    <Form.Item
                        label="Resim"
                        name="image"
                        rules={[
                            {
                                required: true,
                                message: 'Başlık Giriniz',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Başlık"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: 'Başlık Giriniz',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Metin"
                        name="content"
                        rules={[
                            {
                                required: true,
                                message: 'Metin giriniz',
                            },
                        ]}
                    >
                        <TextEditor/>
                    </Form.Item>

                    <div className="form-button">
                        <Button className="submit-btn" loading={loading}  type="primary" htmlType="submit">
                            Kaydet
                        </Button>
                    </div>
                </Form>
            </div>
        </LayoutComponent>
    )
}
